export enum RequestType {
    POST = 'POST',
    GET = 'GET',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
    RSOCKET_STREAM = 'RSOCKET_STREAM',
    IOT_STREAM = 'IOT_STREAM',
}
